// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { Organization } from '@medplum/fhirtypes';
import { STEDI_PAYER_NETWORK_SYSTEM } from '../constants/eligibility';

export function getPayorId(org: Organization | undefined): string {
  return org?.identifier?.find((i) => i.system === STEDI_PAYER_NETWORK_SYSTEM)?.value ?? org?.name ?? '—';
}
